import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SimulationContext = createContext(null);

export function SimulationProvider({ children }) {
  const [state, setState] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function load() {
      try {
        const { data } = await api.get("/simulation/state");
        if (mounted) setState(data);
      } catch (e) {
        // keep last known state on transient errors
      }
    }
    load();
    const id = setInterval(load, 5000);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  return <SimulationContext.Provider value={state}>{children}</SimulationContext.Provider>;
}

export function useSimulation() {
  return useContext(SimulationContext);
}
